import React from "react";
import { cls } from "@wss/cls";

import { TopperSection } from "../../../../types";

import Title from "../../../../components/Title";
import Section from "../../../../components/Section";
import Carousel from "../../../../components/Carousel";

import { getTopperVariant } from "../../../utility";

const Single = ({ sectionId, displayType, name, items }: TopperSection) => {
  const TopperVariant = getTopperVariant(displayType);
  const topperItems = items.map((item, index) => (
    <>
      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      {/* @ts-ignore */}
      <TopperVariant {...item} key={item.itemId} itemIndex={index} />
    </>
  ));

  return (
    <>
      <Title
        className={cls(
          "quick-filter__nav",
          "flex justify-start",
          "md:justify-center"
        )}
        role="tablist"
        data-testid="topper-nav"
      >
        <Title.Header>{name}</Title.Header>
      </Title>
      <Section
        data-testid={`topper-section-${sectionId}`}
        className={cls({
          "min-h-[80px]": [1, 2].includes(displayType),
          "min-h-[100px]": ![1, 2].includes(displayType),
        })}
      >
        <div className="relative">
          <Carousel
            displayType={displayType}
            wrapperProps={{
              className: cls("flex justify-start", "md:justify-center"),
            }}
            topperItems={topperItems}
          />
        </div>
      </Section>
    </>
  );
};

export default Single;
